import React, { FC, useContext } from 'react';

import { SettingsBlock, SettingsFrame } from 'components';
import { LocalizationContext } from 'localization';

import {
  Booking,
  ShowSeansOnMap,
  VirtualHost,
  PostPayment,
  ExpiredBooking,
} from './components';

export const Seances: FC = () => {
  const { t } = useContext(LocalizationContext);

  return (
    <>
      <SettingsBlock title={t('seances')}>
        <SettingsFrame>
          <Booking />
        </SettingsFrame>

        <SettingsFrame>
          <ExpiredBooking />
        </SettingsFrame>

        <SettingsFrame>
          <ShowSeansOnMap />
        </SettingsFrame>

        {/*<SettingsFrame>*/}
        {/*  <GuestClientSessions />*/}
        {/*</SettingsFrame>*/}

        <SettingsFrame>
          <VirtualHost />
        </SettingsFrame>

        <SettingsFrame>
          <PostPayment />
        </SettingsFrame>
      </SettingsBlock>
    </>
  );
};
